(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function initPdpScrollReveals(rootEl) {
    if (!rootEl) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      rootEl.querySelectorAll(".pdp-reveal, .pdp-reveal-group").forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -7% 0px" }
    );
    rootEl.querySelectorAll(".pdp-reveal-group, .pdp-reveal").forEach(function (el) {
      if (el.classList.contains("pdp-reveal") && el.closest(".pdp-reveal-group")) return;
      revealObserver.observe(el);
    });
  }

  function initPdpOfferCountdown(rootEl) {
    var countdown = rootEl.querySelector("[data-pdp-offer-countdown]");
    if (!countdown || countdown.dataset.init) return;
    countdown.dataset.init = "1";

    var timeEl = countdown.querySelector("[data-pdp-countdown-time]");
    if (!timeEl) return;

    var storageKey = "resorse_sale_countdown_end";
    var minMinutes = 30;
    var maxMinutes = 3 * 60;

    function ensureEndTime() {
      var stored = sessionStorage.getItem(storageKey);
      var end = stored ? parseInt(stored, 10) : 0;
      if (!end || end <= Date.now()) {
        var totalMinutes = minMinutes + Math.floor(Math.random() * (maxMinutes - minMinutes + 1));
        end = Date.now() + totalMinutes * 60 * 1000;
        sessionStorage.setItem(storageKey, String(end));
      }
      return end;
    }

    function pad2(value) {
      return String(value).padStart(2, "0");
    }

    function tick() {
      var secondsLeft = Math.max(0, Math.floor((ensureEndTime() - Date.now()) / 1000));
      var hours = Math.floor(secondsLeft / 3600);
      var minutes = Math.floor((secondsLeft % 3600) / 60);
      var seconds = secondsLeft % 60;
      timeEl.textContent = pad2(hours) + ":" + pad2(minutes) + ":" + pad2(seconds);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  ready(function () {
    var root = document.querySelector(".pdp[data-product-pdp]");
    if (!root) return;

    var header = document.querySelector(".desktop-sticky-header");
    if (header && root.classList.contains("pdp--alarm")) {
      function syncGalleryHeaderHeight() {
        root.style.setProperty("--pdp-header-height", header.offsetHeight + "px");
      }
      syncGalleryHeaderHeight();
      new ResizeObserver(syncGalleryHeaderHeight).observe(header);
    }

    initPdpScrollReveals(root);
    initPdpOfferCountdown(root);

    var liveVisitorsEl = root.querySelector("[data-pdp-live-visitors]");
    if (liveVisitorsEl) {
      var liveVisitorsCount = 44 + Math.floor(Math.random() * 7) + Math.floor(Math.random() * 7);

      function updateLiveVisitors() {
        var visitorsChange = Math.floor(Math.random() * 5) - 2;
        if (visitorsChange === 0) visitorsChange = Math.random() < 0.5 ? -1 : 1;
        liveVisitorsCount = Math.max(40, Math.min(60, liveVisitorsCount + visitorsChange));
        liveVisitorsEl.textContent = String(liveVisitorsCount);
        window.setTimeout(updateLiveVisitors, 10000 + Math.floor(Math.random() * 5001));
      }

      liveVisitorsEl.textContent = String(liveVisitorsCount);
      window.setTimeout(updateLiveVisitors, 10000 + Math.floor(Math.random() * 5001));
    }

    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var variants = [];
    var priceMap = {};
    var mediaMap = {};

    try {
      var jv = document.getElementById("pdp-variants-json");
      if (jv && jv.textContent) variants = JSON.parse(jv.textContent);
    } catch (e) {}

    try {
      var jp = document.getElementById("pdp-price-map");
      if (jp && jp.textContent) priceMap = JSON.parse(jp.textContent);
    } catch (e) {}

    try {
      var jm = document.getElementById("pdp-variant-media");
      if (jm && jm.textContent) mediaMap = JSON.parse(jm.textContent);
    } catch (e) {}

    var bundleCartMap = {};
    try {
      var jbc = document.getElementById("pdp-bundle-cart-variants");
      if (jbc && jbc.textContent) bundleCartMap = JSON.parse(jbc.textContent);
    } catch (e3) {}

    var priceEl = root.querySelector("[data-pdp-price-main]");
    var compareEl = root.querySelector("[data-pdp-compare-main]");
    var saveEl = root.querySelector("[data-pdp-save-main]");
    var bundleSaveEl = root.querySelector("[data-pdp-bundle-save-main]");
    var soldRow = root.querySelector("[data-pdp-sold-row]");
    var stickyPrice = root.querySelector("[data-pdp-sticky-price]");
    var stickyBar = root.querySelector(".pdp-sticky");
    var submitBtns = root.querySelectorAll('button[name="add"], [data-bundle-desktop-atc]');

    function findVariantInList(sel, list, loose) {
      var L = list || variants;
      return L.find(function (v) {
        if (!loose) {
          if (sel.length >= 1 && (v.option1 || "") !== (sel[0] || "")) return false;
          if (sel.length >= 2 && (v.option2 || "") !== (sel[1] || "")) return false;
          if (sel.length >= 3 && (v.option3 || "") !== (sel[2] || "")) return false;
          return true;
        }
        for (var i = 0; i < 3; i++) {
          var vVal = i === 0 ? v.option1 : i === 1 ? v.option2 : v.option3;
          vVal = vVal == null ? "" : String(vVal);
          var sVal = i < sel.length && sel[i] != null ? String(sel[i]) : "";
          if (vVal.length > 0 && vVal !== sVal) return false;
        }
        return true;
      });
    }

    function findVariant(sel) {
      return findVariantInList(sel, variants, false);
    }

    function variantsForBundleRadio(radio) {
      if (!radio) return variants;
      var ds = radio.dataset ? radio.dataset.cartVariants : null;
      if (ds) {
        try {
          var parsed = JSON.parse(ds);
          if (Array.isArray(parsed) && parsed.length) return parsed;
        } catch (e4) {}
      }
      if (bundleCartMap && typeof bundleCartMap === "object") {
        var alt = bundleCartMap[String(radio.value)];
        if (alt && Array.isArray(alt) && alt.length) return alt;
      }
      return variants;
    }

    function getSelectedFromButtons() {
      var groups = root.querySelectorAll(".pdp__option-group");
      var max = -1;
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        if (idx > max) max = idx;
      });
      var sel = [];
      for (var i = 0; i <= max; i++) {
        var group = root.querySelector('.pdp__option-group[data-option-index="' + i + '"]');
        var btn = group ? group.querySelector("[data-bundle-colour-select], .pdp__opt.is-selected") : null;
        sel.push(btn ? btn.value || btn.getAttribute("data-value") || "" : "");
      }
      return sel;
    }

    function getSelectedFromButtonsInCard(card) {
      if (!card) return [];
      var groups = card.querySelectorAll(".pdp__option-group");
      var max = -1;
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        if (!isNaN(idx) && idx > max) max = idx;
      });
      var sel = [];
      for (var i = 0; i <= max; i++) {
        var group = card.querySelector('.pdp__option-group[data-option-index="' + i + '"]');
        var btn = group ? group.querySelector("[data-bundle-colour-select], .pdp__opt.is-selected:not(.pdp__opt--bundle-extra)") : null;
        sel.push(btn ? btn.value || btn.getAttribute("data-value") || "" : "");
      }
      return sel;
    }

    function readBundleDiscountCode(radio) {
      if (!radio) return "";
      var a = typeof radio.getAttribute === "function" ? radio.getAttribute("data-bundle-discount") : null;
      var d = radio.dataset && radio.dataset.bundleDiscount;
      var raw = (a != null && String(a).length ? a : d) || "";
      return String(raw).trim();
    }

    function cartAddJsPath(form) {
      var action = form.getAttribute("action") || "/cart/add";
      try {
        var u = new URL(action, window.location.href);
        u.pathname = u.pathname.replace(/\/cart\/add\/?$/, "/cart/add.js");
        return u.pathname + u.search;
      } catch (e) {
        return "/cart/add.js";
      }
    }

    function getVariantForBundleSlot(card, slot, baseSel, cartVariants) {
      var toySelect = card.querySelector('[data-bundle-product-select][data-bundle-slot="' + (slot === 1 ? 2 : slot) + '"]');
      if (toySelect) {
        if (slot === 1) return variants.find(function (v) { return String(v.id) === String(variantInput.value); }) || null;
        var selectedToy = toySelect.options[toySelect.selectedIndex];
        var toyId = selectedToy ? Number(selectedToy.value) : 0;
        if (!Number.isSafeInteger(toyId) || toyId <= 0 || selectedToy.disabled) return null;
        return { id: toyId, available: selectedToy.getAttribute("data-available") === "true" };
      }
      var V = cartVariants || variants;
      var loose = V !== variants;
      if (slot === 1) {
        return findVariantInList(baseSel, V, loose);
      }
      var g = card.querySelector('.pdp__bundle-extra-group[data-bundle-slot="' + slot + '"]');
      if (!g) return null;
      var btn = g.querySelector("[data-bundle-colour-select], .pdp__opt--bundle-extra.is-selected");
      if (!btn) return null;
      var rawOi = btn.getAttribute("data-option-index");
      var oi = rawOi !== null && rawOi !== "" ? parseInt(rawOi, 10) : 0;
      if (isNaN(oi) || oi < 0) oi = 0;
      var val = btn.value || btn.getAttribute("data-value") || "";
      var sel = baseSel.slice();
      while (sel.length <= oi) sel.push("");
      sel[oi] = val;
      return findVariantInList(sel, V, loose);
    }

    function isMobilePdp() {
      return window.matchMedia("(max-width: 900px)").matches;
    }

    function syncPdpStickyBottom() {
      if (!stickyBar || !window.visualViewport) return;
      if (!isMobilePdp()) {
        stickyBar.style.bottom = "";
        return;
      }
      var vv = window.visualViewport;
      var inset = window.innerHeight - vv.height - vv.offsetTop;
      if (inset < 0) inset = 0;
      stickyBar.style.bottom = Math.round(inset) + "px";
    }

    function setStickyVisible(visible) {
      if (!stickyBar) return;
      var on = visible && isMobilePdp();
      stickyBar.classList.toggle("is-visible", on);
      document.body.classList.toggle("pdp-sticky-active", on);
      if (!on) stickyBar.style.bottom = "";
      else syncPdpStickyBottom();
    }

    function initPdpStickyReveal() {
      if (!stickyBar) return;
      setStickyVisible(true);
    }

    function slideIndexForMediaId(mediaId) {
      var slides = root.querySelectorAll(".pdp__main-slide");
      var idx = 0;
      slides.forEach(function (s, i) {
        if (String(s.getAttribute("data-media-id")) === String(mediaId)) idx = i;
      });
      return idx;
    }

    function syncThumbsToSlideIndex(idx) {
      var slides = root.querySelectorAll(".pdp__main-slide");
      var thumbs = root.querySelectorAll(".pdp__thumb");
      if (!slides[idx]) return;
      var sid = slides[idx].getAttribute("data-media-id");
      thumbs.forEach(function (t) {
        t.classList.toggle("is-active", String(t.getAttribute("data-media-id")) === String(sid));
      });
    }

    function loadGalleryVideo(slide) {
      var wrap = slide && slide.querySelector("[data-pdp-video-html]");
      if (!wrap) return slide && slide.querySelector("video");
      var holder = document.createElement("div");
      holder.innerHTML = wrap.getAttribute("data-pdp-video-html") || "";
      var vid = holder.querySelector("video");
      if (!vid) return null;
      var poster = wrap.querySelector(".pdp__video-poster");
      if (poster) poster.replaceWith(vid);
      else wrap.insertBefore(vid, wrap.firstChild);
      wrap.removeAttribute("data-pdp-video-html");
      if (window.initGalleryVideo) window.initGalleryVideo(wrap);
      return vid;
    }

    var galleryInteracted = false;

    function setActiveSlide(idx, smoothScroll) {
      var inner = root.querySelector(".pdp__main-inner");
      var slides = root.querySelectorAll(".pdp__main-slide");
      if (!slides.length) return;
      idx = Math.max(0, Math.min(idx, slides.length - 1));
      syncThumbsToSlideIndex(idx);
      if (isMobilePdp()) {
        slides.forEach(function (s) {
          s.removeAttribute("hidden");
        });
        if (inner && slides[idx]) {
          inner.scrollTo({
            left: slides[idx].offsetLeft,
            behavior: smoothScroll ? "smooth" : "auto"
          });
        }
      } else {
        slides.forEach(function (s, i) {
          if (i !== idx) s.setAttribute("hidden", "");
          else s.removeAttribute("hidden");
        });
      }
      updateGalleryVideos();
    }

    function updateGalleryVideos() {
      var slides = root.querySelectorAll(".pdp__main-slide");
      if (!slides.length) return;
      var activeIdx = getCurrentSlideIndex();
      slides.forEach(function (s, i) {
        var vid = i === activeIdx && galleryInteracted ? loadGalleryVideo(s) : s.querySelector("video");
        if (!vid) return;
        if (i === activeIdx) {
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!vid.paused) {
          try { vid.pause(); } catch (e) {}
        }
      });
    }

    function activateMediaById(mediaId) {
      setActiveSlide(slideIndexForMediaId(mediaId), false);
    }

    function getCurrentSlideIndex() {
      var thumbs = root.querySelectorAll(".pdp__thumb");
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains("is-active")) {
          return slideIndexForMediaId(thumbs[i].getAttribute("data-media-id"));
        }
      }
      var slides = root.querySelectorAll(".pdp__main-slide");
      for (var j = 0; j < slides.length; j++) {
        if (!slides[j].hasAttribute("hidden")) return j;
      }
      return 0;
    }

    var galleryAutoTimer = null;
    var GALLERY_AUTO_MS = 15000;

    function restartGalleryAutoplay() {
      if (galleryAutoTimer) {
        clearInterval(galleryAutoTimer);
        galleryAutoTimer = null;
      }
      if (!galleryInteracted) return;
      var slides = root.querySelectorAll(".pdp__main-slide");
      if (slides.length <= 1) return;
      if (document.hidden) return;
      galleryAutoTimer = setInterval(function () {
        var s2 = root.querySelectorAll(".pdp__main-slide");
        if (!s2.length) return;
        var cur = getCurrentSlideIndex();
        // If the active slide is a video still playing, wait — its "ended"
        // event will advance the carousel so it doesn't cut off mid-video.
        var curVid = s2[cur] && s2[cur].querySelector("video");
        if (curVid && !curVid.paused && !curVid.ended) return;
        var next = (cur + 1) % s2.length;
        setActiveSlide(next, isMobilePdp());
      }, GALLERY_AUTO_MS);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (galleryAutoTimer) {
          clearInterval(galleryAutoTimer);
          galleryAutoTimer = null;
        }
      } else {
        restartGalleryAutoplay();
      }
    });

    function syncSubmitSoldForSelectedBundle() {
      function applySold(available) {
        if (soldRow) soldRow.style.display = available ? "none" : "";
        submitBtns.forEach(function (b) {
          b.disabled = !available;
        });
      }

      var radio = root.querySelector(".bundle-deal-input:checked");
      if (!radio) {
        var vNoBundle = findVariant(getSelectedFromButtons());
        var hasInventory = vNoBundle && (vNoBundle.inventoryQuantity > 0 || vNoBundle.available);
        applySold(hasInventory);
        return;
      }

      var card = radio.closest(".bundle-card");
      if (card && card.querySelector('[data-bundle-product-select], [data-bundle-colour-select]')) {
        var toyCount = parseInt(radio.getAttribute("data-bundle-qty"), 10) || 1;
        for (var slot = 1; slot <= toyCount; slot++) {
          var toy = getVariantForBundleSlot(card, slot, getSelectedFromButtonsInCard(card));
          if (!toy || !toy.available) {
            applySold(false);
            return;
          }
        }
        applySold(true);
        return;
      }
      var cartList = variantsForBundleRadio(radio);
      var bundleProducts = parseInt(radio.getAttribute("data-bundle-qty"), 10) || 1;

      if (cartList !== variants) {
        if (!card) {
          applySold(false);
          return;
        }
        var baseSel = getSelectedFromButtonsInCard(card);
        var multiSlot =
          bundleProducts >= 2 &&
          (function () {
            for (var sm = 2; sm <= bundleProducts; sm++) {
              if (!card.querySelector('.pdp__bundle-extra-group[data-bundle-slot="' + sm + '"]')) {
                return false;
              }
            }
            return true;
          })();
        var maxSlot = multiSlot ? bundleProducts : 1;
        var allOk = true;
        for (var s = 1; s <= maxSlot; s++) {
          var vSlot = getVariantForBundleSlot(card, s, baseSel, cartList);
          if (!vSlot) {
            allOk = false;
            break;
          }
        }
        applySold(allOk);
        return;
      }

      var vMain = findVariant(getSelectedFromButtons());
      var hasInventory = vMain && (vMain.inventoryQuantity > 0 || vMain.available);
      applySold(hasInventory);
    }

    function formatCentsLikeSample(cents, sample) {
      var amount = (cents / 100).toFixed(2);
      var s = sample || "";
      if (s.indexOf("Dhs") >= 0) return "Dhs " + amount.replace(".", ",");
      if (s.indexOf("€") >= 0) return "€" + amount.replace(".", ",");
      if (s.indexOf("$") >= 0) return "$" + amount;
      if (s.indexOf("£") >= 0) return "£" + amount;
      return amount;
    }

    function applyBundlePdpPrice() {
      var card = root.querySelector(".bundle-card.is-selected:not(.bundle-card--static)");
      if (!card) {
        var pill0 = root.querySelector(".pdp__save-pill");
        if (pill0) {
          pill0.classList.remove("pdp__save-pill--gold");
          pill0.classList.remove("pdp__save-pill--mystery-gift");
        }
        var vR = findVariant(getSelectedFromButtons());
        if (vR) setVariant(vR);
        syncSubmitSoldForSelectedBundle();
        return;
      }
      var v = findVariant(getSelectedFromButtons());
      var pm = v && (priceMap[String(v.id)] || priceMap[v.id]);
      var bundleSaveLabel = card.getAttribute("data-bundle-save-label") || "";
      var compareMult = parseFloat(card.getAttribute("data-bundle-compare-mult") || "0");
      var priceMult = parseFloat(card.getAttribute("data-bundle-price-mult") || "1");
      var priceDiscount = parseInt(card.getAttribute("data-bundle-price-discount") || "0", 10) || 0;
      var fixedPrice = parseInt(card.getAttribute("data-bundle-fixed-price") || "0", 10) || 0;
      var comparePriceMult = parseFloat(card.getAttribute("data-bundle-compare-price-mult") || "1") || 1;
      var priceText = pm && pm.price_html ? pm.price_html : card.getAttribute("data-bundle-pdp-price") || "";
      var compareText = card.getAttribute("data-bundle-pdp-compare") || "";

      if (pm && pm.price_cents) {
        var displayCents = fixedPrice || (Math.round(pm.price_cents * priceMult) - priceDiscount);
        if (displayCents < 0) displayCents = 0;
        priceText = formatCentsLikeSample(displayCents, pm.price_html || priceText);
      }

      var autoSave = card.getAttribute("data-bundle-auto-save") === "true";
      if (pm && pm.price_cents && (fixedPrice || autoSave)) {
        compareText = formatCentsLikeSample(Math.round(pm.price_cents * priceMult), pm.price_html || priceText);
      } else if (pm && pm.price_cents && compareMult >= 1) {
        // Struck price = shown price / (1 - discount). compareMult already = 100/(100-discount).
        compareText = formatCentsLikeSample(Math.round(displayCents * compareMult), pm.price_html || priceText);
      }
      if (autoSave && pm && pm.price_cents > 0) {
        var regularCents = Math.round(pm.price_cents * priceMult);
        var savedPercent = regularCents > 0 ? Math.max(0, Math.round((regularCents - displayCents) * 100 / regularCents)) : 0;
        bundleSaveLabel = "SAVE " + savedPercent + "%";
        card.setAttribute("data-bundle-save-label", bundleSaveLabel);
        card.querySelectorAll(".bundle-card__alarm-save").forEach(function (badge) {
          badge.textContent = bundleSaveLabel;
        });
      }

      if (priceText != null && String(priceText).replace(/\s/g, "").length) {
        if (priceEl) {
          priceEl.innerHTML = "";
          priceEl.textContent = priceText;
        }
        if (stickyPrice) {
          stickyPrice.innerHTML = "";
          stickyPrice.textContent = priceText;
        }
        if (compareEl) {
          if (compareText != null && String(compareText).replace(/\s/g, "").length) {
            compareEl.style.display = "";
            compareEl.innerHTML = "";
            compareEl.textContent = compareText;
          } else {
            compareEl.style.display = "none";
          }
        }
        if (bundleSaveEl) {
          var savePill = bundleSaveEl.closest(".pdp__save-pill");
          if (String(bundleSaveLabel).replace(/\s/g, "").length) {
            var isTemplateCThirdBundle =
              !autoSave &&
              document.body.classList.contains("template-suffix-main-product-c") &&
              (card.getAttribute("data-bundle-card") || "") === "3";
            bundleSaveEl.textContent = isTemplateCThirdBundle
              ? "FREE MYSTERY GIFT + " + bundleSaveLabel
              : bundleSaveLabel;
            if (savePill) {
              savePill.style.display = "";
              savePill.classList.toggle(
                "pdp__save-pill--gold",
                !autoSave && ((card.getAttribute("data-bundle-card") || "") === "2" || isTemplateCThirdBundle)
              );
              savePill.classList.toggle("pdp__save-pill--mystery-gift", isTemplateCThirdBundle);
            }
          } else if (savePill) {
            savePill.style.display = "none";
            savePill.classList.remove("pdp__save-pill--gold");
            savePill.classList.remove("pdp__save-pill--mystery-gift");
          }
        }
        if (saveEl) saveEl.style.display = "none";
      } else {
        var v0 = findVariant(getSelectedFromButtons());
        if (v0) setVariant(v0);
      }
      syncSubmitSoldForSelectedBundle();
    }

    var bundleSwatchTouched = false;

    function hasBundleDealRadios() {
      return !!root.querySelector(".bundle-deal-input");
    }

    function shouldSkipVariantGallery() {
      if (!hasBundleDealRadios()) return false;
      if (!root.querySelector(".bundle-card.is-selected:not(.bundle-card--static)")) return false;
      return !bundleSwatchTouched;
    }

    function setVariant(v) {
      if (!v || !variantInput) return;
      variantInput.value = v.id;
      var url = new URL(window.location.href);
      if (root.classList.contains("pdp--alarm")) {
        url.searchParams.delete("variant");
        if (url.searchParams.get("view") === "alarmtemplate") url.searchParams.delete("view");
      } else {
        url.searchParams.set("variant", v.id);
      }
      window.history.replaceState({}, "", url.toString());

      var pm = priceMap[String(v.id)] || priceMap[v.id];
      if (pm && priceEl) priceEl.innerHTML = pm.price_html || "";
      if (pm && compareEl) {
        if (pm.compare_html && pm.compare_html.length) {
          compareEl.style.display = "";
          compareEl.innerHTML = pm.compare_html;
        } else {
          compareEl.style.display = "none";
        }
      }
      if (pm && saveEl) {
        if (pm.save_label && pm.save_label.length) {
          saveEl.style.display = "";
          saveEl.textContent = pm.save_label;
        } else {
          saveEl.style.display = "none";
        }
      }
      syncSubmitSoldForSelectedBundle();
      if (stickyPrice && pm) {
        stickyPrice.innerHTML = pm.price_html || "";
      }

      var mid = mediaMap[String(v.id)] !== undefined ? mediaMap[String(v.id)] : mediaMap[v.id];
      if (mid && !shouldSkipVariantGallery()) activateMediaById(mid);

      restartGalleryAutoplay();
    }

    root.querySelectorAll(".pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        galleryInteracted = true;
        setActiveSlide(slideIndexForMediaId(thumb.getAttribute("data-media-id")), true);
        restartGalleryAutoplay();
      });
    });

    // Gallery video sound: videos autoplay muted (browser requirement). We try
    // to enable sound by default as soon as the browser allows it (first user
    // interaction), and expose a small mute/unmute toggle on each video.
    (function () {
      var wraps = root.querySelectorAll(".pdp__main-vid-wrap[data-pdp-video]");
      if (!wraps.length) return;

      function syncBtn(wrap) {
        var vid = wrap.querySelector("video");
        var btn = wrap.querySelector("[data-pdp-mute]");
        if (!vid || !btn) return;
        var muted = vid.muted || vid.volume === 0;
        btn.classList.toggle("is-muted", muted);
        btn.setAttribute("aria-pressed", String(muted));
      }

      window.initGalleryVideo = function (wrap) {
        if (!wrap || wrap.dataset.videoInit) return;
        var vid = wrap.querySelector("video");
        var btn = wrap.querySelector("[data-pdp-mute]");
        if (!vid || !btn) return;
        wrap.dataset.videoInit = "1";
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          vid.muted = !vid.muted;
          if (!vid.muted) {
            if (vid.volume === 0) vid.volume = 1;
            // Re-kick playback in case the browser paused it.
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          }
          syncBtn(wrap);
        });
        vid.addEventListener("volumechange", function () { syncBtn(wrap); });
        // When the video finishes, advance the carousel (only if this video's
        // slide is the active one) so the autoscroll resumes from here.
        vid.addEventListener("ended", function () {
          var slides = root.querySelectorAll(".pdp__main-slide");
          if (!slides.length) return;
          var cur = getCurrentSlideIndex();
          if (slides[cur] !== wrap.closest(".pdp__main-slide")) return;
          var next = (cur + 1) % slides.length;
          setActiveSlide(next, isMobilePdp());
          restartGalleryAutoplay();
        });
      };

      wraps.forEach(function (wrap) {
        window.initGalleryVideo(wrap);
      });

      var soundEnabled = false;
      function enableSoundOnce() {
        if (soundEnabled) return;
        soundEnabled = true;
        galleryInteracted = true;
        // Unmute every video, but only the currently-active slide is allowed to
        // actually play (updateGalleryVideos enforces play/pause by slide).
        wraps.forEach(function (wrap) {
          var vid = wrap.querySelector("video");
          if (!vid) return;
          vid.muted = false;
          if (vid.volume === 0) vid.volume = 1;
          syncBtn(wrap);
        });
        updateGalleryVideos();
        document.removeEventListener("pointerdown", enableSoundOnce);
        document.removeEventListener("touchstart", enableSoundOnce);
        document.removeEventListener("keydown", enableSoundOnce);
        document.removeEventListener("scroll", enableSoundOnce);
      }
      // Try immediately (works on desktop after any prior page interaction),
      // then fall back to the first explicit user gesture.
      document.addEventListener("pointerdown", enableSoundOnce, { passive: true });
      document.addEventListener("touchstart", enableSoundOnce, { passive: true });
      document.addEventListener("keydown", enableSoundOnce);
      document.addEventListener("scroll", enableSoundOnce, { passive: true });

      // Play the active slide's video (muted) on load; keep the rest paused.
      updateGalleryVideos();
    })();

    var mainInner = root.querySelector(".pdp__main-inner");
    if (mainInner) {
      var scrollSnapTimer;
      function syncDotsFromGalleryScroll() {
        if (!isMobilePdp()) return;
        var w = mainInner.clientWidth || 1;
        var idx = Math.round(mainInner.scrollLeft / w);
        var slides = root.querySelectorAll(".pdp__main-slide");
        idx = Math.max(0, Math.min(idx, slides.length - 1));
        galleryInteracted = true;
        syncThumbsToSlideIndex(idx);
        updateGalleryVideos();
      }
      mainInner.addEventListener("scroll", function () {
        if (!isMobilePdp()) return;
        clearTimeout(scrollSnapTimer);
        scrollSnapTimer = setTimeout(syncDotsFromGalleryScroll, 60);
      });
      mainInner.addEventListener("scrollend", function () {
        if (!isMobilePdp()) return;
        clearTimeout(scrollSnapTimer);
        syncDotsFromGalleryScroll();
        restartGalleryAutoplay();
      });
    }

    window.matchMedia("(max-width: 900px)").addEventListener("change", function () {
      setActiveSlide(getCurrentSlideIndex(), false);
      setStickyVisible(true);
      syncPdpStickyBottom();
    });

    initPdpStickyReveal();

    if (stickyBar && window.visualViewport) {
      syncPdpStickyBottom();
      window.visualViewport.addEventListener("resize", syncPdpStickyBottom);
      window.visualViewport.addEventListener("scroll", syncPdpStickyBottom);
    }

    root.querySelectorAll(".pdp__opt").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("pdp__opt--pair2") || btn.classList.contains("pdp__opt--bundle-extra")) return;
        var rawIdx = btn.getAttribute("data-option-index");
        if (rawIdx === null || rawIdx === "") return;
        var optIdx = parseInt(rawIdx, 10);
        if (isNaN(optIdx)) return;
        var val = btn.getAttribute("data-value") || "";
        var groups = root.querySelectorAll('.pdp__option-group[data-option-index="' + optIdx + '"]');
        if (!groups.length) return;
        groups.forEach(function (group) {
          group.querySelectorAll(".pdp__opt").forEach(function (b) {
            if (b.classList.contains("pdp__opt--pair2") || b.classList.contains("pdp__opt--bundle-extra")) return;
            b.classList.remove("is-selected");
          });
        });
        groups.forEach(function (group) {
          group.querySelectorAll(".pdp__opt").forEach(function (b) {
            if (b.classList.contains("pdp__opt--pair2") || b.classList.contains("pdp__opt--bundle-extra")) return;
            if ((b.getAttribute("data-value") || "") === val) b.classList.add("is-selected");
          });
        });
        var sel = getSelectedFromButtons();
        var v = findVariant(sel);
        if (btn.closest(".bundle-deals")) bundleSwatchTouched = true;
        if (v) setVariant(v);
        applyBundlePdpPrice();
      });
    });

    var cur = variants.find(function (v) {
      return String(v.id) === String(variantInput.value);
    });
    if (cur) setVariant(cur);
    restartGalleryAutoplay();

    var bundleInputs = root.querySelectorAll(".bundle-deal-input");
    var qtyInput = root.querySelector("[data-pdp-qty-input]");
    var offerInput = root.querySelector("[data-bundle-offer-input]");
    var compareInput = root.querySelector("[data-bundle-compare-input]");
    var saveLabelInput = root.querySelector("[data-bundle-save-input]");

    function bundleSaveLabelFor(radio) {
      var card = radio && radio.closest ? radio.closest(".bundle-card") : null;
      return card ? (card.getAttribute("data-bundle-save-label") || "").trim() : "";
    }

    // Bundle strikethrough price per unit (cents), so the cart drawer can
    // show the same compare price as the selected bundle offer.
    function bundleCompareUnitCents(radio) {
      var card = radio && radio.closest ? radio.closest(".bundle-card") : null;
      if (!card) return 0;
      var cents = parseInt(card.getAttribute("data-bundle-compare-cents") || "0", 10) || 0;
      var units = parseInt(radio.getAttribute("data-bundle-qty") || "1", 10) || 1;
      if (units < 1) units = 1;
      return cents > 0 ? Math.round(cents / units) : 0;
    }

    function syncBundleUi() {
      bundleInputs.forEach(function (inp) {
        var card = inp.closest(".bundle-card");
        if (card) {
          var on = inp.checked;
          card.classList.toggle("is-selected", on);
          card.querySelectorAll("button.pdp__opt, input[type='hidden'], [data-bundle-colour-select]").forEach(function (el) {
            if (el.classList && el.classList.contains("bundle-deal-input")) return;
            el.disabled = !on;
          });
        }
        if (inp.checked && qtyInput) {
          var bq = inp.getAttribute("data-bundle-qty");
          if (bq != null && String(bq).length) qtyInput.value = bq;
          else {
            var cq = inp.getAttribute("data-cart-qty");
            if (cq != null && String(cq).length) qtyInput.value = cq;
          }
        }
        if (inp.checked && offerInput && inp.getAttribute("data-offer")) {
          offerInput.value = inp.getAttribute("data-offer");
        }
        if (inp.checked && compareInput) {
          var cuc = bundleCompareUnitCents(inp);
          compareInput.value = cuc > 0 ? String(cuc) : "";
          compareInput.disabled = cuc <= 0;
        }
        if (inp.checked && saveLabelInput) {
          var slb = bundleSaveLabelFor(inp);
          saveLabelInput.value = slb;
          saveLabelInput.disabled = !slb;
        }
      });
      if (stickyBar) {
        var selectedBundle = root.querySelector(".bundle-deal-input:checked");
        var selectedCard = selectedBundle ? selectedBundle.closest(".bundle-card") : null;
        stickyBar.classList.toggle(
          "pdp-sticky--gold-offer",
          !!selectedCard && selectedCard.getAttribute("data-bundle-card") === "2"
        );
      }
      applyBundlePdpPrice();
    }

    bundleInputs.forEach(function (inp) {
      inp.addEventListener("change", function () {
        bundleSwatchTouched = false;
        syncBundleUi();
        var selCard = inp.closest(".bundle-card");
        if (selCard) {
          requestAnimationFrame(function () {
            var isTemplateCDesktop =
              document.body.classList.contains("template-suffix-main-product-c") &&
              window.matchMedia("(min-width: 901px)").matches;
            if (isTemplateCDesktop) {
              var cardIndex = selCard.getAttribute("data-bundle-card");
              if (cardIndex === "1" || cardIndex === "3") {
                var desktopCta = root.querySelector('.pdp__form > button[type="submit"].pdp__submit--cta');
                if (desktopCta) desktopCta.scrollIntoView({ behavior: "smooth", block: "nearest" });
              }
              return;
            }
            selCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
          });
        }
      });
    });
    root.querySelectorAll("[data-bundle-product-select]").forEach(function (select) {
      function syncSecondToy() {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var card = select.closest(".bundle-card");
        var thirdToy = select.getAttribute("data-bundle-slot") === "3";
        var names = card.querySelectorAll(thirdToy ? "[data-bundle-third-name]" : "[data-bundle-second-name]");
        var images = card.querySelectorAll(thirdToy ? "[data-bundle-third-image]" : "[data-bundle-second-image]");
        names.forEach(function (name) { name.textContent = option.getAttribute("data-label") || option.textContent; });
        images.forEach(function (image) { image.src = option.getAttribute("data-image") || ""; });
        syncSubmitSoldForSelectedBundle();
      }
      select.addEventListener("change", syncSecondToy);
      syncSecondToy();
    });
    root.querySelectorAll("[data-bundle-colour-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        var slot = select.getAttribute("data-bundle-slot");
        root.querySelectorAll('[data-bundle-colour-select][data-bundle-slot="' + slot + '"]').forEach(function (picker) {
          picker.value = select.value;
          var option = picker.options[picker.selectedIndex];
          var image = picker.closest(".bundle-card__toy-row").querySelector("img");
          if (option && image) {
            image.src = option.getAttribute("data-image");
            image.alt = option.textContent + " OFFGUARD™ alarm";
          }
        });
        bundleSwatchTouched = true;
        var variant = findVariant([select.value]);
        if (slot === "1" && variant) setVariant(variant);
        else if (variant && mediaMap[String(variant.id)]) activateMediaById(mediaMap[String(variant.id)]);
        applyBundlePdpPrice();
        restartGalleryAutoplay();
      });
    });
    syncBundleUi();

    root.addEventListener("click", function (e) {
      var atcBtn = e.target.closest("[data-bundle-desktop-atc]");
      if (!atcBtn || atcBtn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var card = atcBtn.closest(".bundle-card");
      if (!card) return;
      var inp = card.querySelector(".bundle-deal-input");
      if (!inp) return;
      inp.checked = true;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
      syncBundleUi();
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        var ev = document.createEvent("Event");
        ev.initEvent("submit", true, true);
        form.dispatchEvent(ev);
      }
    });

    form.addEventListener("submit", function (e) {
      var selRadio = root.querySelector(".bundle-deal-input:checked");
      var hasBundles = root.querySelectorAll(".bundle-deal-input").length > 0;
      if (!selRadio || (!qtyInput && !hasBundles)) {
        e.preventDefault();
        var _vidInput = form.querySelector('input[name="id"]');
        var _vid = _vidInput ? parseInt(_vidInput.value, 10) : 0;
        if (!_vid) {
          window.alert("Could not add to cart: invalid variant.");
          return;
        }
        var _qtyInput = form.querySelector('input[name="quantity"]');
        var _qty = _qtyInput ? parseInt(_qtyInput.value, 10) || 1 : 1;
        var _action = form.getAttribute("action") || "/cart/add";
        var _fd = new FormData(form);
        fetch(_action, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(_fd),
          redirect: "manual",
        })
          .then(function (r) {
            if (r.type === "opaqueredirect") {
              if (typeof window.CartDrawer === "object" && window.CartDrawer) {
                window.CartDrawer.afterAdd("");
              } else {
                window.location.href = "/cart";
              }
              return;
            }
            if (!r.ok) return r.text();
            return null;
          })
          .then(function (errBody) {
            if (errBody != null) {
              var msg = "Could not add to cart";
              try {
                var j = JSON.parse(errBody);
                msg = j.description || j.message || (j.errors && typeof j.errors === "string" ? j.errors : j.errors && j.errors[0]) || (j.error || msg);
              } catch (_) {
                var m = errBody.match(/<title>([^<]+)<\/title>/i);
                if (m) msg = m[1];
              }
              window.alert(msg);
            }
          })
          .catch(function () {
            window.alert("Could not add to cart");
          });
        return;
      }
      var selRadio2 = root.querySelector(".bundle-deal-input:checked");

      var bundleProducts = parseInt(selRadio.getAttribute("data-bundle-qty"), 10) || 1;
      var shown = qtyInput ? parseInt(qtyInput.value, 10) || 1 : bundleProducts;
      var bundleCount = Math.max(1, Math.round(shown / bundleProducts));

      var card = selRadio.closest(".bundle-card");

      var useMultiLineAdd =
        bundleProducts >= 2 &&
        card &&
        (function () {
          for (var s = 2; s <= bundleProducts; s++) {
            if (!card.querySelector('.pdp__bundle-extra-group[data-bundle-slot="' + s + '"]')) {
              return false;
            }
          }
          return true;
        })();

      if (!useMultiLineAdd) {
        var autoDisc = readBundleDiscountCode(selRadio);
        var accessoryVariant = selRadio.getAttribute("data-bundle-accessory-variant");
        var accessoryId = Number(accessoryVariant);
        if (accessoryVariant !== null && (!Number.isSafeInteger(accessoryId) || accessoryId <= 0)) {
          e.preventDefault();
          window.alert("The bundle gift is unavailable. Could not add this bundle to cart.");
          return;
        }
        if (autoDisc || accessoryId) {
          e.preventDefault();
          var cvD = variantsForBundleRadio(selRadio);
          var cardD = selRadio.closest(".bundle-card");
          if (cardD && cvD !== variants) {
            var sD = getSelectedFromButtonsInCard(cardD);
            var vD = findVariantInList(sD, cvD, true);
            if (vD) variantInput.value = vD.id;
          }
          var qLine = String(bundleCount * bundleProducts);
          var vid = parseInt(variantInput.value, 10);
          if (!vid) {
            window.alert("Could not add to cart: invalid variant.");
            return;
          }
          var off = (offerInput && offerInput.value) || selRadio.getAttribute("data-offer") || "";
          var propsD = {};
          if (off) propsD.Offer = off;
          var cucD = bundleCompareUnitCents(selRadio);
          if (cucD > 0) propsD._compare_unit_cents = String(cucD);
          var slbD = bundleSaveLabelFor(selRadio);
          if (slbD) propsD._save_label = slbD;
          var itemsD = [{ id: vid, quantity: parseInt(qLine, 10) || 1, properties: propsD }];
          if (accessoryId) itemsD.push({ id: accessoryId, quantity: bundleCount });
          var pathD = cartAddJsPath(form);
          fetch(pathD, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: itemsD }),
          })
            .then(function (r) {
              return r.json().then(function (j) {
                return { ok: r.ok, j: j };
              });
            })
            .then(function (res) {
              if (!res.ok) {
                var msg =
                  (res.j && (res.j.description || res.j.message)) ||
                  (res.j && res.j.errors && String(res.j.errors)) ||
                  "";
                window.alert(msg || "Could not add to cart");
                return;
              }
              if (typeof window.CartDrawer === "object" && window.CartDrawer) {
                window.CartDrawer.afterAdd(autoDisc);
                return;
              }
              window.location.href = "/cart";
            })
            .catch(function () {
              window.alert("Could not add to cart");
            });
          return;
        }
        var cv0 = variantsForBundleRadio(selRadio);
        var card0 = selRadio.closest(".bundle-card");
        if (card0 && cv0 !== variants) {
          var sfix = getSelectedFromButtonsInCard(card0);
          var vfix = findVariantInList(sfix, cv0, true);
          if (vfix) variantInput.value = vfix.id;
        }
        if (qtyInput) qtyInput.value = String(bundleCount * bundleProducts);
        return;
      }

      var cartVariants = variantsForBundleRadio(selRadio);
      var baseSel = getSelectedFromButtonsInCard(card);
      var vList = [];
      for (var s = 1; s <= bundleProducts; s++) {
        var v = getVariantForBundleSlot(card, s, baseSel, cartVariants);
        if (!v) {
          e.preventDefault();
          window.alert("Could not find a variant for item #" + s + ". Check your selections.");
          return;
        }
        vList.push(v);
      }

      var externalOfferProduct = cartVariants !== variants;
      if (!externalOfferProduct) {
        for (var vi = 0; vi < vList.length; vi++) {
          if (!vList[vi].available) {
            e.preventDefault();
            window.alert(
              "Item #" +
                (vi + 1) +
                " is not available for this product. Choose another option."
            );
            return;
          }
        }
      }

      e.preventDefault();

      var offer = (offerInput && offerInput.value) || selRadio.getAttribute("data-offer") || "";
      var cucM = bundleCompareUnitCents(selRadio);
      var slbM = bundleSaveLabelFor(selRadio);

      var items = [];
      for (var p = 0; p < bundleCount; p++) {
        for (var slot = 1; slot <= bundleProducts; slot++) {
          var v = vList[slot - 1];
          var props = {};
          if (offer) props.Offer = offer;
          if (cucM > 0) props._compare_unit_cents = String(cucM);
          if (slbM) props._save_label = slbM;
          items.push({ id: v.id, quantity: 1, properties: props });
        }
      }

      var signsVariant = selRadio.getAttribute("data-bundle-accessory-variant");
      if (signsVariant !== null) {
        var signsId = Number(signsVariant);
        if (!Number.isSafeInteger(signsId) || signsId <= 0) {
          window.alert("The bundle gift is unavailable. Could not add this bundle to cart.");
          return;
        }
        items.push({ id: signsId, quantity: bundleCount });
      }

      var path = cartAddJsPath(form);
      fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (j) {
            return { ok: r.ok, j: j };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg =
              (res.j && (res.j.description || res.j.message)) ||
              (res.j && res.j.errors && String(res.j.errors)) ||
              "";
            window.alert(msg || "Could not add to cart");
            return;
          }
          var discAfter = readBundleDiscountCode(selRadio);
          if (typeof window.CartDrawer === "object" && window.CartDrawer) {
            window.CartDrawer.afterAdd(discAfter);
            return;
          }
          window.location.href = "/cart";
        })
        .catch(function () {
          window.alert("Could not add to cart");
        });
    });

    root.querySelectorAll(".pdp__opt--bundle-extra").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var slot = btn.getAttribute("data-bundle-slot");
        if (!slot) return;
        var val = btn.getAttribute("data-value") || "";
        root.querySelectorAll('.pdp__bundle-extra-group[data-bundle-slot="' + slot + '"]').forEach(function (group) {
          group.querySelectorAll(".pdp__opt--bundle-extra").forEach(function (b) {
            b.classList.toggle("is-selected", (b.getAttribute("data-value") || "") === val);
          });
        });
        bundleSwatchTouched = true;
        var sel = getSelectedFromButtons().slice();
        var oi = btn.getAttribute("data-option-index");
        if (oi != null && oi !== "") {
          var optIdx = parseInt(oi, 10);
          if (!isNaN(optIdx) && optIdx >= 0) {
            while (sel.length <= optIdx) sel.push("");
            sel[optIdx] = val;
            var vImg = findVariant(sel);
            if (vImg) {
              var mid = mediaMap[String(vImg.id)] !== undefined ? mediaMap[String(vImg.id)] : mediaMap[vImg.id];
              if (mid) activateMediaById(mid);
            }
          }
        }
        restartGalleryAutoplay();
      });
    });

    root.querySelectorAll("[data-pdp-mini-reviews]").forEach(function (wrap) {
      var viewport = wrap.querySelector(".pdp-mini-reviews__viewport");
      var slides = wrap.querySelectorAll(".pdp-mini-reviews__slide");
      var dots = wrap.querySelectorAll(".pdp-mini-reviews__dot");
      if (!viewport || !slides.length) return;

      var n = slides.length;
      var current = 0;
      var autoTimer = null;
      var scrollEndTimer = null;
      var ignoreScroll = false;
      var AUTO_MS = 30000;

      function slideW() {
        return viewport.clientWidth || 1;
      }

      function setDots(idx) {
        var i = Math.max(0, Math.min(idx, n - 1));
        dots.forEach(function (d, j) {
          d.classList.toggle("is-active", j === i);
          d.setAttribute("aria-selected", j === i ? "true" : "false");
        });
        current = i;
      }

      function scrollToIdx(idx, smooth) {
        var i = Math.max(0, Math.min(idx, n - 1));
        var x = i * slideW();
        ignoreScroll = true;
        viewport.scrollTo({ left: x, behavior: smooth ? "smooth" : "auto" });
        setDots(i);
        setTimeout(function () {
          ignoreScroll = false;
        }, smooth ? 520 : 80);
      }

      function idxFromScroll() {
        var w = slideW();
        return Math.max(0, Math.min(Math.round(viewport.scrollLeft / w), n - 1));
      }

      function restartAuto() {
        clearInterval(autoTimer);
        if (n <= 1) return;
        autoTimer = setInterval(function () {
          scrollToIdx((current + 1) % n, true);
        }, AUTO_MS);
      }

      viewport.addEventListener(
        "scroll",
        function () {
          if (ignoreScroll) return;
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            setDots(idxFromScroll());
            restartAuto();
          }, 150);
        },
        { passive: true }
      );

      if (dots.length) {
        dots.forEach(function (d, i) {
          d.addEventListener("click", function () {
            scrollToIdx(i, true);
            restartAuto();
          });
        });
      }

      if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(function () {
          ignoreScroll = true;
          viewport.scrollTo({ left: current * slideW(), behavior: "auto" });
          setTimeout(function () {
            ignoreScroll = false;
          }, 80);
        }).observe(viewport);
      }

      setDots(0);
      viewport.scrollLeft = 0;
      restartAuto();
    });

    root.querySelectorAll("[data-pdp-ugc-carousel]").forEach(function (carousel) {
      var viewport = carousel.querySelector(".pdp-ugc__track");
      var cells = carousel.querySelectorAll(".pdp-ugc__cell");
      var nextBtn = carousel.querySelector("[data-pdp-ugc-next]");
      var prevBtn = carousel.querySelector("[data-pdp-ugc-prev]");
      if (!viewport || !cells.length) return;

      var n = cells.length;
      var current = 0;
      var scrollEndTimer = null;
      var ignoreScroll = false;
      var ugcObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        syncVideos(current);
        ugcObserver.disconnect();
      }, { rootMargin: "150px" });
      ugcObserver.observe(carousel);

      function slideW() {
        return !isMobilePdp() && n > 1
          ? cells[1].offsetLeft - cells[0].offsetLeft || 1
          : viewport.clientWidth || 1;
      }

      function lastIndex() {
        return Math.max(0, n - (isMobilePdp() ? 1 : 3));
      }

      function loadVideo(cell) {
        var lazy = cell.querySelector("[data-pdp-ugc-video-html]");
        if (!lazy) return cell.querySelector("video");
        var holder = document.createElement("div");
        holder.innerHTML = lazy.getAttribute("data-pdp-ugc-video-html") || "";
        var video = holder.querySelector("video");
        if (!video) return null;
        lazy.replaceWith(video);
        return video;
      }

      function syncVideos(idx) {
        cells.forEach(function (cell, j) {
          var visible = j >= idx && j < idx + (isMobilePdp() ? 1 : 3);
          var v = visible ? loadVideo(cell) : cell.querySelector("video");
          if (!v) return;
          if (visible) {
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      function scrollToIdx(idx, smooth) {
        var i = Math.max(0, Math.min(idx, lastIndex()));
        ignoreScroll = true;
        viewport.scrollTo({ left: i * slideW(), behavior: smooth ? "smooth" : "auto" });
        current = i;
        syncVideos(i);
        setTimeout(function () {
          ignoreScroll = false;
        }, smooth ? 520 : 80);
      }

      function idxFromScroll() {
        return Math.max(0, Math.min(Math.round(viewport.scrollLeft / slideW()), lastIndex()));
      }

      viewport.addEventListener(
        "scroll",
        function () {
          if (ignoreScroll) return;
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            var i = idxFromScroll();
            current = i;
            syncVideos(i);
          }, 120);
        },
        { passive: true }
      );

      if (nextBtn) {
        nextBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (current < lastIndex()) scrollToIdx(current + 1, true);
          else scrollToIdx(0, true);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          scrollToIdx(current > 0 ? current - 1 : lastIndex(), true);
        });
      }

      if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(function () {
          scrollToIdx(current, false);
        }).observe(viewport);
      }

      window.matchMedia("(max-width: 900px)").addEventListener("change", function () {
        scrollToIdx(current, false);
      });

      if (isMobilePdp()) {
        viewport.scrollLeft = 0;
      }
    });
  });
})();
